/** Tipurile de serviciu, ca in wizardul aplicatiei vechi — o singura lista pentru
 *  oferte, rezervari si filtre, ca sa nu apara variante diferite pe ecrane diferite. */
export const TIPURI_SERVICIU = [
  { v: 'SEJUR_CHARTER', t: 'Pachet turistic (charter / sejur)' },
  { v: 'CAZARE', t: 'Cazare' },
  { v: 'BILET_AVION', t: 'Bilet de avion' },
  { v: 'CIRCUIT', t: 'Circuit / excursie' },
  { v: 'AUTOCAR', t: 'Transport autocar' },
  { v: 'CROAZIERA', t: 'Croaziera' },
  { v: 'TRATAMENT', t: 'Tratament balnear' },
  { v: 'ASIGURARE', t: 'Asigurare' },
  { v: 'TRANSFER', t: 'Transfer' },
  { v: 'ALTELE', t: 'Alte servicii' },
]

export const MONEDE = [{ v: 'EUR', t: 'EUR' }, { v: 'RON', t: 'RON' }, { v: 'USD', t: 'USD' }]

export const ETAPE_REZERVARE = [
  { v: 'Optiune', t: 'In optiune' },
  { v: 'Confirmata', t: 'Confirmata' },
  { v: 'Finalizata', t: 'Finalizata' },
  { v: 'Anulata', t: 'Anulata' },
]

export const azi = () => new Date().toISOString().slice(0, 10)
